import React from 'react';
import { destinations } from '../data';

const Result = ({ answers, onRestart }) => {
  if (!answers || answers.length === 0) {
    return <div>Nenhuma resposta fornecida.</div>;
  }

  const scoreCount = {};

  answers.forEach(answer => {
    if (answer && answer.score !== undefined) {
      if (scoreCount[answer.score]) {
        scoreCount[answer.score]++;
      } else {
        scoreCount[answer.score] = 1;
      }
    }
  });

  const maxScore = Object.keys(scoreCount).reduce((a, b) => scoreCount[a] > scoreCount[b] ? a : b, 0);
  const resultDestination = destinations[maxScore] || { description: "Destino desconhecido", image: "", details: { text: "", cta: "", link: "" } };

  return (
    <div className="result-container">
      <div className="result-content">
        <h2>Seu destino ideal é:</h2>
        <h3>{resultDestination.description}</h3>
        {resultDestination.image && (
          <img 
            src={resultDestination.image} 
            alt={resultDestination.description} 
            className="result-image" 
            style={{ maxWidth: '100%', borderRadius: '10px', marginBottom: '20px' }}
          />
        )}
        <p style={{ marginBottom: '20px', fontSize: '16px', lineHeight: '1.5', textAlign: 'justify' }}>
          {resultDestination.details.text}
        </p>
        <a 
          href={resultDestination.details.link} 
          target="_blank" 
          rel="noopener noreferrer" 
          className="blog-link"
          style={{
            display: 'inline-block',
            backgroundColor: '#007BFF',
            color: '#fff',
            padding: '10px 20px',
            borderRadius: '5px',
            textDecoration: 'none',
            marginBottom: '20px',
            textAlign: 'center'
          }}
        >
          {resultDestination.details.cta}
        </a>
        <button 
          onClick={onRestart} 
          className="restart-button"
          style={{
            display: 'inline-block',
            marginTop: '20px',
            padding: '10px 20px',
            backgroundColor: '#6c757d',
            color: '#fff',
            border: 'none',
            borderRadius: '5px',
            cursor: 'pointer'
          }}
        >
          Recomeçar Quiz
        </button>
      </div>
    </div>
  );
};

export default Result;
